export const DATE_UN_SHOT = require('./date-un-shot.jpg');
export const NOSOTROS = require('./nosotros.jpg');
export const PANDA_MIX = require('./panda-mix.png');
export const PANDA_TRONIC = require('./panda-tronic.png');
export const PANDA_YELLOW = require('./panda-yellow.png');
export const PANDA_PURPLE = require('./purple-fusion.png');
export const PRODUCTOS = require('./productos.png');
export const CLIENTES = require('./clientes.png');
export const EVENTOS = require('./eventos.png');
export const EXPERIENCIA = require('./experiencia.png');
export const COOLER = require('./cooler.png');
export const PIDE_PANDA = require('./pide-panda.png');
export const PANDA_LOGO = require('./panda-logo.png');
export const PRODUCTOS_TAB = require('./productos-tab.png');
export const SHOW_TAB = require('./show-tab.png');
export const PANDAPARTY_TAB = require('./pandaparty-tab.png');
export const EXTRA_CO2 = require('./extra-co2.png');
export const EXTRA_DINO = require('./extra-dino.png');
export const EXTRA_VIDEO = require('./extra-video.png');
export const CARRITO = require('./carrito.png');
export const PASO_1 = require('./paso-1.png');
export const PASO_2 = require('./paso-2.png');
export const PASO_3 = require('./paso-3.png');
export const PASO_4 = require('./paso-4.png');
export const PRODUCTOS_RESUMEN = require('./productos-resumen.png');
export const MINI_PANDA_RESUMEN = require('./mini-panda-resumen.png');
export const MAGIC_PANDA_RESUMEN = require('./magic-panda-resumen.png');
export const SHOW_RESUMEN = require('./show-resumen.png');
export const PANDA_PARTY_RESUMEN = require('./panda-party-resumen.png');
export const TETERO_BUTTON = require('./tetero-button.png');
export const TETERO_BUTTON_HOVER = require('./tetero-button-hover.png');
export const WARNING_PANDA = require('./warning-panda.png');
export const INSTAGRAM = require('./instagram-logo.png');
export const VER_CARRITO = require('./ver-carrito.png');
export const PANDA_FACE = require('./panda-face.png');
